export const processTableData = <T extends Record<string, unknown>>(
    data: T[],
    options: {
        include: (keyof T)[]
    } = {
        include: [],
    }
): { [K in keyof T]: T[K] }[] => {
    const keysToInclude = options.include.length
        ? options.include
        : Object.keys(data[0] ?? {})

    const filteredData = data.map((obj) => {
        return Object.fromEntries(
            Object.entries(obj).filter(([key]) => keysToInclude.includes(key))
        ) as T
    })

    return filteredData
}
